import { createAsyncThunk } from '@reduxjs/toolkit';
import { toApiError } from '@/services/api/responseHandler';
import { mediaService } from '@/services/media/mediaService';
import type {
  AddMediaToCartPayload,
  MediaCartResponse,
  MediaCartSummaryResponse,
} from '@/types/media';

export const addMediaToCartThunk = createAsyncThunk<
  MediaCartResponse,
  AddMediaToCartPayload,
  { rejectValue: ReturnType<typeof toApiError> }
>('media/addToCart', async (payload, { rejectWithValue }) => {
  try {
    return await mediaService.addToCart(payload);
  } catch (error) {
    return rejectWithValue(toApiError(error));
  }
});

export const fetchMediaCartThunk = createAsyncThunk<
  MediaCartSummaryResponse,
  void,
  { rejectValue: ReturnType<typeof toApiError> }
>('media/fetchCart', async (_, { rejectWithValue }) => {
  try {
    return await mediaService.getCart();
  } catch (error) {
    return rejectWithValue(toApiError(error));
  }
});
